import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'oaj-loader-itx',
  styleUrls: ['./loader.component.css'],
  templateUrl: './loader.component.html',
})

export class LoaderComponent {
  @Input() public loading = false;
  @Input() public failed = false;
  @Input() public sMensaje="Cargando..."
  @Input() public sMensajeError = 'Ocurrio un error al cargar la información';
  @Input() public loadingClass = false;


  
@HostBinding('class.loading-overlay')
  get isLoadingClass() {
    return this.loadingClass;
  }

}
